// Autogenerated file, DO NOT MODIFY or it will be overwritten;
import type { SVGProps } from 'react';

import { forwardRef } from '@chakra-ui/react';

import { Icon, type IconProps } from '../Icon';

const Svg = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <rect width={16} height={1.75} x={4} y={4.852} fill="#6421B9" rx={0.875} />
    <rect width={16} height={1.75} x={4} y={11.102} fill="#6421B9" rx={0.875} />
    <rect width={16} height={1.75} x={4} y={17.352} fill="#6421B9" rx={0.875} />
  </svg>
);
const IconHamburger = forwardRef((props: Omit<IconProps, 'icon'>, ref) => {
  return <Icon ref={ref} icon={Svg} {...props} />;
});
export default IconHamburger;
